import Manager from "../../src/manager";
import React from "react";

function Mapper(data, status, response, error, component) {
    let output = [];

    return output;
}

function Properties(args) {
    let editable = args.editable ? true : false;
    return {
        id: {
            alias:"id",
            type:"text",
            editable
        }
    };
}

const Header = {
    auth: "",
    views: {
        list: {
            apis: {
                view: {
                    data: [{}],
                    replace: {},
                    mapper: Mapper,
                },
            },
            template: "header",
            templateConfiguration: {
                includeProperties: [],
                excludeProperties: [],
                events: {onClick: function (e){}},
            },
            properties: Properties({ editable: false }),
            primaryKey: "id",
        },
    },
};

export default Header;